import { Text, View, YStack } from 'tamagui';

import PSRichText from '@/components/ui/PSRichText';
import type { Faq } from '@/src/lib/faqs';
import PSText from './ui/PSText';

/**
 * FaqLedger — the FAQ with nothing hidden (molecule).
 *
 * The Access Pass landing page's FAQ, chosen over three accordions (paper
 * cards, hairline rules, cherry-rose bars). It is deliberately NOT an
 * accordion: this is the last block before the footer, nothing below it competes
 * for the scroll, and putting "Will I get a refund? No" behind a tap reads worse
 * than simply saying it. The cost is real and was accepted — the section is
 * long, and the ~150-word no-show answer dominates it. Don't "fix" that by
 * collapsing the rows; that's the design that was rejected.
 *
 * With no surface to carry the brand and no state to signal, `$brandSecondary` on
 * the questions is the only structure: it separates the pairs, so no rules are
 * needed between them.
 *
 * Render-only — there's nothing to open.
 */
export default function FaqLedger({ faqs }: { faqs: Faq[] }) {
  return (
    <YStack gap="$lg">
      <View
        alignSelf="stretch"
        borderBottomWidth="$borderWidth.hairline"
        borderColor="$color.panelTranslucent"
        my={'$space.xxl'}
      />

      <PSText.Title color="$textWhite">FAQs</PSText.Title>

      <YStack gap="$xl">
        {faqs.map((faq) => (
          <YStack key={faq.question} gap="$sm">
            <Text fontSize="$md" fontWeight="$semibold" color="$brandSecondary">
              {faq.question}
            </Text>
            <PSRichText markdown={faq.answer} surface="dark" />
          </YStack>
        ))}
      </YStack>
    </YStack>
  );
}
